import { useQuery } from "@tanstack/react-query";
import { resolveGiftToken } from "@/api/redemption";
import { shouldRetryGiftContext } from "@/utils/redemption-helper";

/** Resolves the gift-link token into recipient + campaign context. */
export function useGiftContext(token: string | undefined) {
  return useQuery({
    queryKey: ["redemption", "giftContext", token],
    queryFn: () => {
      if (!token) throw new Error("Missing gift token");
      return resolveGiftToken(token);
    },
    enabled: !!token,
    retry: shouldRetryGiftContext,
  });
}
